import { useI18n } from "@/i18n/translations";
import { lectiones } from "@/data/events";
import { Seo } from "@/components/Seo";
import { PageHeader, PdfLinkRow } from "@/components/Editorial";

export const Lectiones = () => {
  const { t, lang } = useI18n();
  return (
    <>
      <Seo titleKey="seo.lectiones.title" descKey="seo.lectiones.desc" path="/attivita/lectiones" />
      <PageHeader kickerKey="att.kicker" titleKey="att.lectiones_title">
        <p className="mt-6 max-w-2xl text-base leading-relaxed text-mutedtx">{t("att.lectiones_intro")}</p>
      </PageHeader>
      <div className="container-x pb-20 sm:pb-24">
        <div className="grid gap-6 md:grid-cols-2" data-testid="lectiones-list">
          {lectiones.map((l) => (
            <article key={l.id} className="flex flex-col gap-3 border border-borderc bg-cardwhite p-8" data-testid={`lectio-card-${l.id}`}>
              <span className="eyebrow text-bordeaux">{t("att.lectio_lectio")}</span>
              <h2 className="font-serif text-2xl font-medium leading-snug text-ink">{lang === "en" && l.title.en ? l.title.en : l.title.it}</h2>
              <p className="text-sm text-bodytx/85">
                {l.lecturer} — {l.date.d} {t(`att.mese.${l.date.m}`)} {l.date.y}
              </p>
              {l.description && <p className="text-sm leading-relaxed text-bodytx/85">{lang === "en" && l.description.en ? l.description.en : l.description.it}</p>}
              {l.pdfs.length > 0 && (
                <div className="mt-auto flex flex-wrap gap-x-6 gap-y-2 pt-2">
                  {l.pdfs.map((pdf, i) => (
                    <PdfLinkRow key={i} label={pdf.label} href={pdf.href} />
                  ))}
                </div>
              )}
            </article>
          ))}
        </div>
      </div>
    </>
  );
};

export default Lectiones;
